import { Box, Button, Portal, Typography } from '@mui/material';
import moment from 'moment';
import React, { useRef, useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { showNotificationsAction } from '../../actions/dynamicUI';
import { fetchHistoricNotifications, markNotificationsAsRead } from '../../actions/notifications';
import theme from '../../muiTheme';
import CloseButton from '../Buttons/CloseButton';
import UserAvatar from '../UserAvatar/UserAvatar';

const Notifications = () => {

    const {authData } = useSelector((state) => state.authReducer);
    const {notifications, currentPage, numberOfPages} = useSelector((state) => state.notificationsReducer);
    const {showNotifications } = useSelector((state) => state.dynamicUIReducer);
    const [newlyRead, setNewlyRead] = useState([]);
    const newlyReadRef = useRef([]); //using this as it persists during unmount - unlike state
    const dispatch = useDispatch(); 
    const [limit, setLimit] = useState(6); 
    const [localCurrentPage, setLocalCurrentPage] = useState(1);

    useEffect(()=>{


        return (targetIds = newlyRead) => {

            
            updateToRead(); 
            
        }

    }, []);

    const updateToRead = () => {

        console.log('About to dismount, newlyReadRef: ', newlyReadRef.current);
        //dispatch to set unread notifications on current page to read
        if(newlyReadRef.current.length > 0){

            dispatch(markNotificationsAsRead(authData.result._id, newlyReadRef.current));
            setNewlyRead([]);
        }
    }

    useEffect(()=>{

        newlyReadRef.current = newlyRead; //for keeping ref and state in sync

    }, [newlyRead]);

    useEffect(()=>{

        //mark any unread notifications as read
        let unreadNotiticationsIds = [];

        for(let i = 0; i<limit; i++){

            if(notifications[i] && notifications[i].read === false){
                unreadNotiticationsIds.push(notifications[i]._id);
            }

        }

        console.log('current page changed, unreadNotifications: ', unreadNotiticationsIds);

        setNewlyRead(prevValue => { 

            console.log('setting newlyRead, new value: ', [...unreadNotiticationsIds]);

            let newValue = [...unreadNotiticationsIds];

            return newValue;
        });  

    }, [localCurrentPage, notifications, limit]);

    // useEffect(()=>{

    //     setLocalCurrentPage(currentPage);

    // }, [currentPage]);


    const closeNotifications = () => {

        updateToRead(); 

        dispatch(showNotificationsAction({showNotifications: false}));

        
    }

    const fetchMore = () => {

        //dispatch to set unread notifications on current page to read
        updateToRead(); 

        let merge = false; 

        //first we paginate through local notifications in redux store state
        if(limit < notifications.length){
            
            /*if notifications.length is not a multiple of 6, that means we'll need to fetch more
              from the server to have all the notifications for that last local page. 

              The server will return ALL notifications for that page, and some of which will already be
              in state from the sockets, so we'll need to go through the returned notifications and remove
              duplicates. i.e merge. 

              So we do this by:
              1)   Check if notifications.length - limit < 6
              2)   If 1 is true, fetch more from api, passing the ids to exclude
            */
 
            setLimit(prevValue => prevValue+6);

            if((notifications.length - limit) < 6){

                //get ids to exclude
                let exclude = notifications.slice(limit);

                exclude = exclude.map(item => item._id);

                console.log('excluding: ', exclude);

                dispatch(fetchHistoricNotifications(authData.result._id, localCurrentPage+1, {
                    exclude //array of ids to exlude here
                }));

            }


            setLocalCurrentPage(prevValue => prevValue+1);

            return; 
        }

        //one the above pagination has bottomed out, we fetch more from server
        if(localCurrentPage < numberOfPages){

            let newPage = localCurrentPage+1;

            dispatch(fetchHistoricNotifications(authData.result._id, newPage));
            setLocalCurrentPage(newPage);
            setLimit(prevValue => prevValue+6);
        }

        //the pagination approach being used here, allows only 6 notifications to be marked as read at a time
        //eliminating the need to do complex ref juggling to mark them as read as they come into view
    }


    return (

        <>

            <Box
                sx={{
                    position: 'fixed',
                    width: '50px',
                    height: '50px',
                    top: '95px',
                    right: '147px',
                    zIndex: '1001',
                    background: theme.palette.lightGreen,
                    transform: 'rotate(45deg)',
                    opacity: '1',
                    [theme.breakpoints.down('sm')] : { 
                        display: 'none'
                    }
                }}
            >

            </Box>

            <Box
                className='notfications-container'
                sx={{
                    position: 'fixed',
                    top: '105px',
                    right: '30px',
                    zIndex: '1000',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    background: 'white',
                    borderRadius: '15px',
                    maxHeight: '900px',
                    overflow: 'hidden',
                    width: '400px',
                    opacity: '1',
                    boxShadow: '0px 9px 11px rgb(0 0 0 / 6%)',
                    [theme.breakpoints.down('sm')] : { 
                        top: '0px',
                        right: '0px',
                        borderRadius: '0px',
                        opacity: '1',
                        width: '100%',
                        maxHeight: '100vh',
                        minHeight: '100vh'
                    }
                }}
            >

                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                        height: '200px',
                        padding: '20px',
                        boxSizing: 'border-box',
                        background: theme.palette.lightGreen,
                        color: 'white'
                    }}
                >

                    <Typography variant='h6'>
                        Notifications
                    </Typography>

                    <CloseButton 
                        variant='inverted' 
                        sx={{
                            color: theme.palette.gray
                        }}
                        onClick={closeNotifications}
                    />

                </Box>


                {
                    notifications.length > 0 ?


                    <Box
                        sx={{
                            flex: 9,
                            overflowY: 'scroll',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            justifyContent: 'flex-start',
                            width: '100%',
                            position: 'relative',
                            marginBottom: '15px',
                        }}
                    >

                        {
                            notifications.slice(0, limit).map((notification)=>{


                                //create message
                                let entity = null; 
                                let entityLink = ''; 

                                if(notification.postEntities.length > 0){
                                    entity = notification.postEntities.length > 1 ? 'posts' : 'post';
                                    entityLink = `/posts/${notification.postEntities[0]._id}`

                                }else if(notification.commentEntities.length > 0){

                                    entity = notification.commentEntities.length > 1 ? 'comments' : 'comment';
                                }


                                entity = entity ? <Link onClick={closeNotifications} to={entityLink || '#'} style={{textDecoration: 'none', color: 'inherit'}}><Typography variant='body1' sx={{fontWeight: '600', display: 'inline-block'}} > {` your ${entity}`} </Typography></Link> : <Typography variant='body1' sx={{display: 'inline-block'}}> you </Typography>;   


                                return (
                                    <Box

                                        key={'notification-'+notification._id}
                                    
                                        sx={{
                                            minHeight: '100px',
                                            maxWidth: '100%',
                                            borderRadius: '0px',
                                            background: 'white',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            padding: '0px 20px',
                                            margin: '2px 0px',
                                            borderLeft: notification.read ? `10px solid ${theme.palette.faint}`: `10px solid ${theme.palette.lightGreen}`,
                                            opacity: notification.read? '0.8': '1'

                                        }}

                                    >

                                        <UserAvatar onClick={closeNotifications} imageURL={notification.invokingUser.profileImage} url={`/profile/${notification.invokingUser._id}`} />

                                        
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'flex-start',
                                                justifyContent: 'center',
                                            }}
                                        > 

                                            <Box>
                                                <Typography variant='body1' sx={{fontWeight: '600', display: 'inline-block'}}>{`${notification.invokingUser.name} `} </Typography> 
                                                <Typography variant='body1' sx={{display: 'inline-block', margin: '0px 5px'}}>{` ${notification.action} `}</Typography> 
                                                {entity} 
                                            </Box>

                                            <Typography variant='body2' sx={{marginTop: '3px', color: theme.palette.gray}}>
                                                { moment(notification.createdAt).fromNow()}
                                            </Typography>

                                        </Box>
                                        

                                    </Box>
                                );
                            })
                        }

                        {
                            (limit < notifications.length||(localCurrentPage < numberOfPages)) &&

                            <Box
                                sx={{
                                    flex: 1,
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: '200px',
                                    padding: '20px',
                                    boxSizing: 'border-box',
                                    background: 'white',
                                    color: 'white'
                                }}
                            >

                                <Button variant='main' onClick={fetchMore}> 
                                    See more
                                </Button>

                            </Box>
                        }
                        

                    </Box>

                    :

                    <Box
                        sx={{
                            flex: 9,
                            overflowY: 'scroll',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            position: 'relative',
                            minHeight: '150px'
                        }}
                    >

                        <Typography variant='body1'>
                            No Notifications yet!
                        </Typography>

                    </Box>

                }

                

            </Box>

        </>        
        
    ); 
}

export default Notifications; 